import React from "react";

interface PaginationProps {
  currentPage: number; // 0-indexed from the API
  totalPages: number;
  totalItems: number;
  itemsOnPage: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
  emptyMessage?: string;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  totalItems,
  itemsOnPage,
  onPageChange,
  disabled = false,
  emptyMessage = "No data available.",
}) => {
  // Convert 0-indexed page to 1-indexed for display
  const displayPage = currentPage + 1;
  const displayTotalPages = Math.max(1, totalPages);
  const isFirstPage = currentPage === 0;
  const isLastPage = currentPage >= totalPages - 1 || totalPages === 0;

  const handleFirst = () => {
    if (!isFirstPage && !disabled) onPageChange(0);
  };

  const handlePrev = () => {
    if (!isFirstPage && !disabled) onPageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (!isLastPage && !disabled) onPageChange(currentPage + 1);
  };

  const handleLast = () => {
    if (!isLastPage && !disabled) onPageChange(totalPages - 1);
  };

  if (totalItems === 0) {
    return <div className="empty-state-message">{emptyMessage}</div>;
  }

  return (
    <div className="app-table-footer">
      <span>
        Showing {itemsOnPage} of {totalItems} entries
      </span>
      <div className="pagination-controls">
        <span>
          Page {displayPage} of {displayTotalPages}
        </span>
        <div className="pagination-arrows">
          <img
            src="/assets/tables/table_first.svg"
            alt="First page"
            onClick={handleFirst}
            className={isFirstPage || disabled ? "disabled" : ""}
          />
          <img
            src="/assets/tables/table_prev.svg"
            alt="Previous page"
            onClick={handlePrev}
            className={isFirstPage || disabled ? "disabled" : ""}
          />
          <img
            src="/assets/tables/table_next.svg"
            alt="Next page"
            onClick={handleNext}
            className={isLastPage || disabled ? "disabled" : ""}
          />
          <img
            src="/assets/tables/table_last.svg"
            alt="Last page"
            onClick={handleLast}
            className={isLastPage || disabled ? "disabled" : ""}
          />
        </div>
      </div>
    </div>
  );
};

export default Pagination;
